import {
  Container,
  Row,
  Col,
  Stack,
  ToggleButtonGroup,
  ToggleButton,
  InputGroup,
  Form,
  Button,
  Dropdown,
  Card,
} from "react-bootstrap";
import AppointmentDataTable from "../../common/AppointmentDataTable";
import CircularPercentage from "../../common/CircularPercentage";
import useAnimatedCounter from "../ToDos/useAnimatedCounter";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import { ButtonGroup } from "react-bootstrap";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import { AppointmentHeader, ExportAppointmentHeader } from "./actions/constant";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import DateRangePicker from "../../common/CustomDateRangePicker";
import { addDays, subDays } from "date-fns";
import { Filter } from "lucide-react";
import DropdownInput from "../../common/DropdownInput";
import AppointmentActionsDropdown from "../../common/AppointmentActionsDropdown";
import AppointmentActionDrawer from "./components/AppointmentActionDrawer";

import AssignMyTodo from "./components/AssignMyTodo";

import MedicalAssignment from "./components/MedicalAssignment";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import { fetcheaderinfo } from "../../services/UserRegistrationApi";
import { QME_APPOINTMENT_STATUS, WEB_ROLE } from "../../common/Constant";
import CustomPagination from "../../common/Pagination";
import TableRowsPerPage from "../../common/TableRowsPerPage";
import {
  AppointmentadvanceSearchCaseList,
  getAppointmentSimpleSearch,
  downloadQMEFormsZip,
  getAppointmentActionsAccessList,
  getAppointmentSummaryCard,
  downloadSIBTFForm,
  downloadSIBTFBulkFormsZipForRecordList,
  updateBlink,
} from "../../services/AppointmentsAPI";
import DataTable from "../../common/DataTable";
import AppointmentAdvanceSearch from "./components/AppointmentAdvanceSearch";
import Loader from "../../common/Loader";
import AppointmentActionCommonPopUp from "./components/AppointmentActionCommonPopUp";
import moment from "moment";
import { APPOINTMENT_TAB_ACTIONS } from "../../common/EventConstant";
import GetAppointmentNotes from "./components/GetAppointmentNotes";
import EditorDWCExtensionRequest from "../ToDos/Editor/components/EditorDWCExtensionRequest";
import DoctorCommonDrawer from "../ToDos/Doctor/components/DoctorCommonDrawer";
import { setIsDashboard, setNewCaseInFoID } from "../../redux/slice/CaseHeaderSlice";
import { useLocation, useNavigate } from "react-router-dom";

const Appointments = () => {
  const allowedFeatures = useSelector(
    (state: RootState) => state.featureAccess.allowedFeatures,
  );
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const hasInitialized = useRef(false);
  const [loading, setLoading] = useState<boolean>(false);
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [userRole, setUserRole] = useState("");
  const [appointmentData, setAppointmentData] = useState<any[]>([]);
  const [appointmentCount, setAppointmentCount] = useState(10);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("Today");
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(15);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalRows, setTotalRows] = useState<any>("");
  const [sortColumn, setSortColumn] = useState<string>("");
  const [sortOrder, setSortOrder] = useState<string>("DESC");
  const currentTime = moment(new Date()).format("HH:mm");
  const hasFetchedRef = useRef(false);
  const [dateRange, setDateRange] = useState<
    [Date | undefined, Date | undefined]
  >([undefined, undefined]);

  const [computedMinDate, setComputedMinDate] = useState<Date | undefined>();
  const [computedMaxDate, setComputedMaxDate] = useState<Date | undefined>();

  const [showAppointmentActionDrawer, setShowAppointmentActionDrawer] =
    useState(false);
  const [showRushNotesActionDrawer, setShowRushNotesActionDrawer] =
    useState(false);
      const [showAssignEditorDrawer, setshowAssignEditorDrawer] =
    useState(false);
  const [showAppointmentMAActionDrawer, setShowAppointmentMAActionDrawer] =
    useState(false);
      const [showAssignEditor, setshowAssignEditor] =
    useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [shouldTriggerSearch, setShouldTriggerSearch] = useState(false);
  const [isAdvanceSearchActive, setIsAdvanceSearchActive] = useState(false);

  const [lastAdvanceFilters, setLastAdvanceFilters] = useState<any | null>(
    null,
  );

  const [selectedRowData, setSelectedRowData] = useState<any[]>([]);
  const [showCommonModal, setShowCommonModal] = useState(false);
  const [activeFilter, setActiveFilter] = useState("APPTALL");
  const [activeCard, setActiveCard] = useState<string>("Total");
  const [activeSubCard, setActiveSubCard] = useState<string>("Today");

  const [totalCount, setTotalCount] = useState<string>("");
  const [completedCount, setcompletedCount] = useState<string>("");
  const [completedPercent, setcompletedPercent] = useState<string>("");
  const [pendingCount, setpendingCount] = useState<string>("");
  const [pendingPercent, setpendingPercent] = useState<string>("");
  const [canceledCount, setcanceledCount] = useState<string>("");
  const [canceledPercent, setcanceledPercent] = useState<string>("");

  const [historyCompletedPercent, sethistoryCompletedPercent] =
    useState<string>("");
  const [historyOverduePercent, sethistoryOverduePercent] =
    useState<string>("");
  const [historyNearDuePercent, sethistoryNearDuePercent] =
    useState<string>("");
  const [rorCompletedPercent, setrorCompletedPercent] = useState<string>("");
  const [rorOverduePercent, setrorOverduePercent] = useState<string>("");
  const [rorNearduePercent, setrorNearduePercent] = useState<string>("");
  const [rorWIPPercent, setrorWIPPercent] = useState<string>("");
  const [historyWIPPercent, sethistoryWIPPercent] = useState<string>("");
  const [editingCompletedPercent, seteditingCompletedPercent] =
    useState<string>("");
  const [editingwipPercent, seteditingwipPercent] = useState<string>("");
  const [doctorwipPercent, setdoctorwipPercent] = useState<string>("");
  const [doctoreditorwipPercent, setdoctoreditorwipPercent] =
    useState<string>("");

  const getloggedInUserRole = async () => {
    try {
      const userRole = localStorage.getItem("userrole") || "";
      setUserRole(userRole);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getloggedInUserRole();
  }, [loggedInUserid]);

  const popupActionValues = [
    QME_APPOINTMENT_STATUS.RESCHEDULED,
    QME_APPOINTMENT_STATUS.QME_REQUESTED_RESCHEDULE,
    QME_APPOINTMENT_STATUS.PATIENT_CHECKED_IN,
    QME_APPOINTMENT_STATUS.PATIENT_NO_SHOW,
    QME_APPOINTMENT_STATUS.INTERPRETER_NO_SHOW,
    QME_APPOINTMENT_STATUS.QME_NO_SHOW,
    QME_APPOINTMENT_STATUS.CANCELLED,
    QME_APPOINTMENT_STATUS.COMPLETED,
  ];

  const allOptions = {
     assignToMyTodo: { value: "Change Staff", label: "Change Staff" },
  
    generateForm: { value: "Generate Form", label: "Generate Form" },
    assignMedical: {
      value: "Assign Medical Assistant",
      label: "Assign Medical Assistant",
    },
    reschedule: {
      value: QME_APPOINTMENT_STATUS.RESCHEDULED,
      label: "Reschedule",
    },
    reschedule_request: {
      value: QME_APPOINTMENT_STATUS.QME_REQUESTED_RESCHEDULE,
      label: "Reschedule Request",
    },
    checkin: {
      value: QME_APPOINTMENT_STATUS.PATIENT_CHECKED_IN,
      label: "Patient Checkin",
    },
    patientNoShow: {
      value: QME_APPOINTMENT_STATUS.PATIENT_NO_SHOW,
      label: "Patient No Show",
    },
    interpreterNoShow: {
      value: QME_APPOINTMENT_STATUS.INTERPRETER_NO_SHOW,
      label: "Interpreter No Show",
    },
    doctorNoShow: {
      value: QME_APPOINTMENT_STATUS.QME_NO_SHOW,
      label: "QME Doctor No Show",
    },
    cancel: { value: QME_APPOINTMENT_STATUS.CANCELLED, label: "Cancel" },
    complete: { value: QME_APPOINTMENT_STATUS.COMPLETED, label: "Complete" },
  };

  const optionFeatureMap: Record<string, string> = {
     "Change Staff": APPOINTMENT_TAB_ACTIONS.CHANGESTAFF,
    "Generate Form": APPOINTMENT_TAB_ACTIONS.GENERATE_FORM,
    "Assign Medical Assistant": APPOINTMENT_TAB_ACTIONS.ASSIGN_MA,
    Reschedule: APPOINTMENT_TAB_ACTIONS.RESCHEDULE,
    "Reschedule Request": APPOINTMENT_TAB_ACTIONS.RESCHEDULE,
    "Patient Checkin": APPOINTMENT_TAB_ACTIONS.PATIENT_CHECKIN,
    "Patient No Show": APPOINTMENT_TAB_ACTIONS.PATIENT_NO_SHOW,
    "Interpreter No Show": APPOINTMENT_TAB_ACTIONS.INTERPRETER_NO_SHOW,
    "QME Doctor No Show": APPOINTMENT_TAB_ACTIONS.DOCTOR_NO_SHOW,
    Cancel: APPOINTMENT_TAB_ACTIONS.CANCEL,
    Complete: APPOINTMENT_TAB_ACTIONS.COMPLETED,
  };

  function hasFeatureAccess(featureDesc: string): boolean {
    return allowedFeatures.has(featureDesc?.trim());
  }

  function filterByAccess(options: any[]) {
    return options?.filter((opt) => {
      const featureDesc = optionFeatureMap[opt.label];
      return featureDesc ? hasFeatureAccess(featureDesc) : false;
    });
  }

  const normalizeLabel = (label: string) =>
    label.replace(/-/g, "").trim().toLowerCase();

  const allOptionsList = Object.values(allOptions);

  const optionLookup = allOptionsList.reduce((acc: any, option) => {
    acc[normalizeLabel(option.label)] = option;
    return acc;
  }, {});

  const applyRoleBasedLabel = (option: any, userRole: string) => {
    if (
      userRole === WEB_ROLE.QME_Doctor ||
      userRole === WEB_ROLE.Medical_Assistant
    ) {
      if (option.label === "Reschedule") {
        return { ...option, label: "Request Reschedule" };
      }

      if (option.label === "Cancel") {
        return { ...option, label: "Cancel Request" };
      }
    }

    return option;
  };

  const [filteredActionOptions, setFilteredActionOptions] = useState<any[]>([]);
  const toLocalISOString = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    const [start, end] = dateRange;

    getAppointmentSummaryData(searchQuery, activeFilter);
  }, [dateRange, searchQuery, activeFilter]);

  const getAppointmentSummaryData = async (
    query: string = "",
    action: string = "",
  ) => {
    try {
      // Convert dateRange to ISO strings safely
      const trimmedQuery = query?.trim();
      const [start, end] = dateRange;
      const payload = {
        searchText: query || "",
        startDate: start ? toLocalISOString(start) : null,
        endDate: end ? toLocalISOString(end) : null,
        eventValue: selectedFilter === "Today" ? null : selectedFilter,
      };

      const response = await getAppointmentSummaryCard(payload);

      if (response) {
        setTotalCount(response?.totalAppointments ?? "");
        setcompletedCount(response?.completedAppointments ?? "");
        setcompletedPercent(response?.completedAppointments_Pct ?? "");
        setpendingCount(response?.pendingAppointments ?? "");
        setpendingPercent(response?.pendingAppointments_Pct ?? "");
        setcanceledCount(response?.cancelledAppointments ?? "");
        setcanceledPercent(response?.cancelledAppointments_Pct ?? "");
        sethistoryCompletedPercent(response?.history_Completed_Pct ?? "");
        sethistoryNearDuePercent(response?.history_NearDue_Pct ?? "");
        sethistoryOverduePercent(response?.history_Overdue_Pct ?? "");
        setrorCompletedPercent(response?.ror_Completed_Pct ?? "");
        setrorOverduePercent(response?.ror_Overdue_Pct ?? "");
        setrorNearduePercent(response?.ror_NearDue_Pct ?? "");
        setrorWIPPercent(response?.ror_Wip_Pct ?? "");
        seteditingCompletedPercent(response?.editing_Completed_Pct ?? "");
        seteditingwipPercent(response?.editing_Editor_Wip_Pct ?? "");
        setdoctorwipPercent(response?.editing_Doctor_Wip_Pct ?? "");
        setdoctoreditorwipPercent(response?.editor_Edt_Doc_Wip_Pct ?? "");
        sethistoryWIPPercent(response?.history_Wip_Pct ?? "");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const isDwcExtensionAllowed = (dueDate?: string) => {
    if (!dueDate) return false;

    const due = new Date(dueDate);
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    due.setHours(0, 0, 0, 0);

    const diffInDays =
      (due.getTime() - today.getTime()) / (1000 * 60 * 60 * 24);

    return diffInDays <= 5;
  };

  const getActionBasedOnAppointment = async () => {
    try {
      const scheduleIds = selectedRowData
        ?.map((row) => row.subjectqmescheduleid)
        ?.filter(Boolean);

      if (!scheduleIds?.length) return;

      const payload = {
        subjectQMEScheduleIds: scheduleIds.join(","),
        triggerEvent: selectedFilter.toUpperCase(),
      };

      const apiActions = await getAppointmentActionsAccessList(payload);

      let mappedOptions = apiActions
        .map((apiOpt: any) => {
          const key = normalizeLabel(apiOpt.label);
          return optionLookup[key];
        })
        .filter(Boolean)
        .map((opt) => applyRoleBasedLabel(opt, userRole));

      /** -------- DWC Extension Logic -------- */

      if (
        selectedRowData?.length === 1 &&
        [
          WEB_ROLE.Medical_Assistant,
          WEB_ROLE.Case_Manager,
          WEB_ROLE.Practice_Manager,
        ].includes(userRole)
      ) {
        const dueDate = selectedRowData?.[0]?.dueDate;

        if (dueDate && isDwcExtensionAllowed(dueDate)) {
          mappedOptions = [
            ...mappedOptions,
            {
              label: "DWC Extension",
              value: "DWC Extension",
            },
          ];
        }
      }
      setFilteredActionOptions(mappedOptions);
    } catch (error) {
      console.error("Error fetching appointment actions:", error);
    }
  };

  useEffect(() => {
    if (selectedRowData?.length) {
      getActionBasedOnAppointment();
    }
  }, [selectedRowData, selectedFilter]);

  const handleCheckboxSelect = (selectedRows: any[]) => {
    const ids = selectedRows
      ?.map((r: any) => String(r?.subjectQmeScheduleId))
      ?.filter(Boolean);
    setSelectedIds(ids);
    setSelectedRowData(selectedRows);
  };

  const handleExportExcel = async () => {
    let sheetName = "";
    let title = "";
    const today = new Date().toLocaleDateString("en-US");

    if (selectedFilter === "Past") {
      sheetName = "Past Appointments";
      const formattedStart = dateRange[0]
        ? new Date(dateRange[0]).toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        })
        : "";
      const formattedEnd = dateRange[1]
        ? new Date(dateRange[1]).toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        })
        : "";
      title = `Appointments List for ${formattedStart} - ${formattedEnd} (Past - Start Date & End Date)`;
    } else if (selectedFilter === "Today") {
      sheetName = "Today Appointments";
      title = `Appointments List for ${today} (Today)`;
    } else if (selectedFilter === "Upcoming") {
      sheetName = "Upcoming Appointments";
      const formattedStart = dateRange[0]
        ? new Date(dateRange[0]).toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        })
        : "";
      const formattedEnd = dateRange[1]
        ? new Date(dateRange[1]).toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        })
        : "";
      title = `Appointments List for ${formattedStart} - ${formattedEnd} (Upcoming - Start Date & End Date)`;
    }

    // ✅ Define headers explicitly
    const headers = [
      "Sr. No",
      ...ExportAppointmentHeader.map((h: any) => h.label || h.name),
    ];
    // ✅ Add index+1 as first column in each row
    const [start, end] = dateRange;
    const trimmedQuery = searchQuery?.trim();
    const today1 = new Date();
    today1.setHours(0, 0, 0, 0);

    // Validations only for simple search

    if (selectedFilter === "Today" && (start || end)) return;

    if (selectedFilter === "Past") {
      if (!start || !end) return;
      if (end.getTime() >= today1.getTime()) return;
    }

    if (selectedFilter === "Upcoming") {
      if (!start || !end) return;
      if (start.getTime() <= today1.getTime()) return;
    }

    // ✅ Build rows as arrays (first element = Sr. No)
    const basePayload = {
      actionTrigger: activeFilter,
      eventValue: selectedFilter === "Today" ? null : selectedFilter,
      startDate:
        selectedFilter === "Today" || !start
          ? null
          : start.toISOString().split("T")[0],
      endDate:
        selectedFilter === "Today" || !end
          ? null
          : end.toISOString().split("T")[0],
      pageNumber: 1,
      pageSize: 10000,
      sortColumn: "",
      sortOrder: "DESC",
    };

    const response = await getAppointmentSimpleSearch(basePayload);

    const exportData = response.map((row: any, index: number) => {
      const rowArr: any[] = [];
      rowArr.push(index + 1); // Sr. No first

      ExportAppointmentHeader.forEach((header: any) => {
        let val = row[header.key];
        if (header.key === "caseid" && typeof val === "string") {
          val = val.slice(-3);
        }
        rowArr.push(val);
      });

      return rowArr;
    });

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(sheetName);

    // Title row
    worksheet.mergeCells(1, 1, 1, headers.length);
    const titleCell = worksheet.getCell(1, 1);
    titleCell.value = title;
    titleCell.font = { bold: true, size: 14 };
    titleCell.alignment = { horizontal: "left" };

    // Header row
    const headerRow = worksheet.addRow(headers);
    headerRow.font = { bold: true };

    // Data rows
    exportData.forEach((rowArr: any[]) => {
      worksheet.addRow(rowArr);
    });

    // Adjust column widths
    worksheet.columns.forEach((col, index) => {
      if (col) {
        col.width = index === 0 ? 10 : 25; // Sr. No smaller
      }
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      `${title}.xlsx`,
    );
  };

  const getBase64FromUrl = async (url: string): Promise<string> => {
    const res = await fetch(url);
    const blob = await res.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (typeof reader.result === "string") {
          resolve(reader.result);
        } else {
          reject("Failed to convert blob to base64");
        }
      };
      reader.onerror = () => reject("Failed to read blob");
      reader.readAsDataURL(blob);
    });
  };
  const handleExportPDF = async () => {
    let title = "";
    const today = new Date().toLocaleDateString("en-US");

    if (selectedFilter === "Past") {
      const formattedStart = dateRange[0]
        ? new Date(dateRange[0]).toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        })
        : "";
      const formattedEnd = dateRange[1]
        ? new Date(dateRange[1]).toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        })
        : "";
      title = `Appointments List for ${formattedStart} - ${formattedEnd} (Past - Start Date & End Date)`;
    } else if (selectedFilter === "Today") {
      title = `Appointments List for ${today} (Today)`;
    } else if (selectedFilter === "Upcoming") {
      const formattedStart = dateRange[0]
        ? new Date(dateRange[0]).toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        })
        : "";
      const formattedEnd = dateRange[1]
        ? new Date(dateRange[1]).toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        })
        : "";
      title = `Appointments List for ${formattedStart} - ${formattedEnd} (Upcoming - Start Date & End Date)`;
    }

    const logoBase64 = await getBase64FromUrl("/logo.png");

    const headers = [
      "Sr. No",
      ...ExportAppointmentHeader.map((h: any) => h.label || h.name),
    ];

    const [start, end] = dateRange;
    const trimmedQuery = searchQuery?.trim();
    const today1 = new Date();
    today1.setHours(0, 0, 0, 0);

    // Validations only for simple search

    if (selectedFilter === "Today" && (start || end)) return;

    if (selectedFilter === "Past") {
      if (!start || !end) return;
      if (end.getTime() >= today1.getTime()) return;
    }

    if (selectedFilter === "Upcoming") {
      if (!start || !end) return;
      if (start.getTime() <= today1.getTime()) return;
    }

    const basePayload = {
      actionTrigger: activeFilter,
      eventValue: selectedFilter === "Today" ? null : selectedFilter,
      startDate:
        selectedFilter === "Today" || !start
          ? null
          : start.toISOString().split("T")[0],
      endDate:
        selectedFilter === "Today" || !end
          ? null
          : end.toISOString().split("T")[0],
      pageNumber: 1,
      pageSize: 10000,
      sortColumn: "",
      sortOrder: "DESC",
    };

    const response = await getAppointmentSimpleSearch(basePayload);

    const tableData = response.map((row: any, index: number) => {
      const obj: any = [];
      obj.push(index + 1); // first column → Sr. No

      ExportAppointmentHeader.forEach((header: any) => {
        let val = row[header.key];

        // if header is caseid → take only last 3 chars
        if (header.key === "caseid" && typeof val === "string") {
          val = val.slice(-3);
        }

        obj.push(val);
      });

      return obj;
    });
    const doc = new jsPDF("landscape", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 10;
    const headerHeight = 20; // reserve space
    const footerHeight = 15;
    autoTable(doc, {
      head: [headers],
      body: tableData,
      margin: { top: 35, left: 2 }, // Reserve space for header & title
      styles: { fontSize: 9, cellPadding: 2, overflow: "linebreak" },
      tableWidth: pageWidth - 0.5 * margin,
      didDrawPage: (data) => {
        // ===== HEADER (every page) =====
        doc.setFontSize(12);
        const leftMargin = 2; // set your desired left margin in points
        doc.text("Medical Legal Portal", leftMargin, 14);

        doc.addImage(logoBase64, "PNG", pageWidth - margin - 28, 5, 34, 12);

        // ===== TITLE (repeat on EVERY page) =====
        doc.setFontSize(14);
        doc.text(title, leftMargin, 26);

        // ===== FOOTER (every page) =====
        const footerY = pageHeight - 10;
        const now = new Date();
        const formattedDate = now.toLocaleString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
        const storedFirstname = localStorage.getItem("firstname");
        const storedLastname = localStorage.getItem("lastname");

        const generatedByText = `Generated By & On - ${storedFirstname} ${storedLastname} ${formattedDate}`;
        const totalPages = doc.getNumberOfPages();
        const pageNumberText = `Page No. ${data.pageNumber} of ${totalPages}`;

        // footer line
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.1);
        doc.line(1, footerY - 5, pageWidth - 1, footerY - 5);

        // footer text
        doc.setFontSize(8);
        doc.text(generatedByText, 1, footerY);
        doc.text(
          pageNumberText,
          pageWidth - 1 - doc.getTextWidth(pageNumberText),
          footerY,
        );
      },
    });

    doc.save(`${title}.pdf`);
  };

  const debounce = (func: Function, delay: number) => {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const handleInputChange = debounce((value: string) => {
    if (value.length >= 3 || value.length === 0) {
      setIsAdvanceSearchActive(false);
      setLastAdvanceFilters(null);
      setSearchQuery(value);
    }
  }, 300);

  const handleActionChange = (value: string | number) => {
    setSelectedAction(value);
    if (value === "Generate Form") {
      const sibtfIds: any[] = [];
      const qmeIds: any[] = [];

      selectedRowData.forEach((row: any) => {
        if (
          row.caseReviewTypeDesc ===
          "SIBTF (Subsequent Injuries Benefits Trust Fund)"
        ) {
          sibtfIds.push(row.subjectqmescheduleid);
        } else {
          qmeIds.push(row.subjectqmescheduleid);
        }
      });

      if (sibtfIds.length > 0) {
        downloadSIBTFBulkFormsZipForRecordList(sibtfIds);
      }

      if (qmeIds.length > 0) {
        downloadQMEFormsZip(qmeIds);
      }

      return;
    }

    const selectedOption = filteredActionOptions.find(
      (option) => option.value === value,
    );

    const label = selectedOption?.label || String(value);
    const Actionvalue = selectedOption?.value || String(value);

    if (value === "Assign Medical Assistant") {
      setDrawerTitle("Assign Medical Assistant");
      setShowAppointmentMAActionDrawer(true);
    } else if (popupActionValues.includes(String(value))) {
      setDrawerTitle(label); // Use label here
      setActionValue(Actionvalue);
      setShowCommonModal(true);
    } else {
      setDrawerTitle(`Action - ${label} (${selectedIds.length})`);
      //setShowAppointmentActionDrawer(true);
    }

     if (value === "Change Staff") {
      setDrawerTitle("Change Staff");
      setshowAssignEditor(true);
    } else if (popupActionValues.includes(String(value))) {
      setDrawerTitle(label); // Use label here
      setActionValue(Actionvalue);
      setShowCommonModal(true);
    } else {
      setDrawerTitle(`Action - ${label} (${selectedIds.length})`);      
    }
  };

  useEffect(() => {
    const today = new Date();
    const yesterday = subDays(today, 1);
    const tomorrow = addDays(today, 1);

    if (selectedFilter === "Past") {
      const defaultStart = subDays(yesterday, 30);
      const defaultEnd = yesterday;
      setDateRange([defaultStart, defaultEnd]);
      setComputedMinDate(subDays(yesterday, 365));
      setComputedMaxDate(yesterday);
    } else if (selectedFilter === "Upcoming") {
      const defaultStart = tomorrow;
      const defaultEnd = addDays(tomorrow, 30);
      setDateRange([defaultStart, defaultEnd]);
      setComputedMinDate(tomorrow);
      setComputedMaxDate(addDays(tomorrow, 365));
    } else {
      setDateRange([undefined, undefined]); // or handle "Today" case
    }

    // Mark that dateRange is being changed intentionally
    setShouldTriggerSearch(true);
  }, [selectedFilter]);

  const handleDateRangeChange = (newRange: [Date | null, Date | null]) => {
    const [start, end] = newRange;
    setDateRange([start ?? undefined, end ?? undefined]);
  };

  const getSearchAppointmentData = async (
    query: string = "",
    pageNumber: number = 1,
    pageSize: number = itemsPerPage,
    key: string = sortColumn,
    direction: string = sortOrder,
    advancedFilters: any = null,
  ) => {
    const [start, end] = dateRange;
    const trimmedQuery = query?.trim();
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Validations only for simple search

    if (selectedFilter === "Today" && (start || end)) return;

    if (selectedFilter === "Past") {
      if (!start || !end) return;
      if (end.getTime() >= today.getTime()) return;
    }

    if (selectedFilter === "Upcoming") {
      if (!start || !end) return;
      if (start.getTime() <= today.getTime()) return;
    }

    // Prepare request payload
    const basePayload = {
      actionTrigger: activeFilter,
      eventValue: selectedFilter === "Today" ? null : selectedFilter,
      startDate:
        selectedFilter === "Today" || !start
          ? null
          : start.toISOString().split("T")[0],
      endDate:
        selectedFilter === "Today" || !end
          ? null
          : end.toISOString().split("T")[0],
      pageNumber,
      pageSize,
      sortColumn: key,
      sortOrder: direction,
    };

    const appointmentRequest = advancedFilters
      ? { ...advancedFilters, ...basePayload } // advanced search
      : { ...basePayload, searchText: trimmedQuery }; // simple search

    setLoading(true);

    try {
      const response = advancedFilters
        ? await AppointmentadvanceSearchCaseList(appointmentRequest)
        : await getAppointmentSimpleSearch(appointmentRequest);

      // Step 3: Set state with updated response
      setAppointmentData(response);
      setAppointmentCount(response.length);
      setTotalPages(response[0]?.totalPages || 1);
      setTotalRows(response[0]?.totalCount || null);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const refreshAppointmentData = () => {
    getSearchAppointmentData(
      inputRef.current?.value || "",
      currentPage,
      itemsPerPage,
      sortColumn,
      sortOrder,
      isAdvanceSearchActive ? lastAdvanceFilters : null,
    );
    setSelectedIds([]); // Clear selected IDs
    setSelectedRowData([]); // Clear full row data
    setSelectAll(false);
  };

  const handleFilterChange = (val: string) => {
    setSelectedFilter(val);
    setCurrentPage(1);
    setTotalPages(1);
    setItemsPerPage(15);
    setSelectedIds([]);
    setSelectAll(false);
  };

  const handleSortAction = (row: any) => {
    setSortColumn(row.key);
    setSortOrder(row.direction);
  };

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handleRowsPerPageChange = (value: number) => {
    setItemsPerPage(value);
    setCurrentPage(1);
  };

  const handleResetFilters = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
    }
    setSearchQuery("");

    setSelectedIds([]); // Clear selected IDs
    setSelectedRowData([]); // Clear full row data
    setSelectAll(false);
    setLastAdvanceFilters(null);
    setIsAdvanceSearchActive(false);
    setSearchQuery("");
    setSelectedFilter("Today");
    setTotalPages(1);
    setCurrentPage(1);
    setSortOrder("DESC");
  };

  const handleSaveFilters = () => {
    setSelectedIds([]); // Clear selected IDs
    setSelectedRowData([]); // Clear full row data
    setSelectAll(false);

    if (inputRef.current) {
      inputRef.current.value = "";
    }
    setSearchQuery("");
    getSearchAppointmentData("", 1, itemsPerPage, sortColumn, sortOrder);
  };

  const [selectedAction, setSelectedAction] = useState<string | number>("");
  const [drawerTitle, setDrawerTitle] = useState("");
  const [actionValue, setActionValue] = useState("");

  const handlecloseActionDrawer = async () => {
    setShowAppointmentActionDrawer(false);
    setShowAppointmentMAActionDrawer(false);
    setShowRushNotesActionDrawer(false);
     setshowAssignEditor(false);
  };

  // Calculate text for the range of entries currently visible
  const entriesText = !totalRows
    ? "Showing 0 of 0 entries"
    : `Showing ${(currentPage - 1) * itemsPerPage + 1} to ${Math.min(
      currentPage * itemsPerPage,
      totalRows,
    )} of ${totalRows} entries`;

  const OpenAdvanceserachPopup = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
    }
    setSearchQuery("");

    setIsPopupOpen(true);
  };

  const CloseAdvanceserachPopup = () => {
    setIsPopupOpen(false);
  };

  const handleCloseCommonModal = () => {
    setShowCommonModal(false);
  };

  const handleOpenNewTabForMap = async () => {
    window.open("/#/appointment/map", "_blank");
  };

  const [selectedCaseId, setSelectedCaseId] = useState<number | null>(null);
  const [selectedQMEScheduleId, setSelectedQMEScheduleId] = useState<number | null>(null);

  const handleTableAction = async (action: string, row: any) => {
    if (action === "openNotes") {           
            const response = await updateBlink(
  row.subjectQmeScheduleId,
  0
);

if (response) {
  refreshAppointmentData();
}     
     
      setSelectedCaseId(row.caseInfoId);
      setSelectedQMEScheduleId(row.subjectQmeScheduleId);
      setShowRushNotesActionDrawer(true);
      setDrawerTitle("Rush Notes");
    }
  };

  const lastDepsRef = useRef<string | null>(null);

  useEffect(() => {
    const [start, end] = dateRange;

    const isReady =
      selectedFilter === "Past" || selectedFilter === "Upcoming"
        ? start && end
        : true;

    if (!isReady) return;

    const currentDeps = JSON.stringify({
      start,
      end,
      selectedFilter,
      searchQuery,
      currentPage,
      itemsPerPage,
      sortColumn,
      sortOrder,
      isAdvanceSearchActive,
      lastAdvanceFilters,
    });

    if (lastDepsRef.current === currentDeps) return;

    lastDepsRef.current = currentDeps;

    getSearchAppointmentData(
      searchQuery,
      currentPage,
      itemsPerPage,
      sortColumn,
      sortOrder,
      isAdvanceSearchActive ? lastAdvanceFilters : null,
    );
  }, [
    dateRange,
    selectedFilter,
    searchQuery,
    currentPage,
    itemsPerPage,
    sortColumn,
    sortOrder,
    isAdvanceSearchActive,
    lastAdvanceFilters,
  ]);

  // useEffect(() => {
  //   if (hasFetchedRef.current) return;

  //   const [start, end] = dateRange;

  //   const isReady =
  //     selectedFilter === "Past" || selectedFilter === "Upcoming"
  //       ? start && end
  //       : true;

  //   if (!isReady) return;

  //   getSearchAppointmentData(
  //     searchQuery,
  //     currentPage,
  //     itemsPerPage,
  //     sortColumn,
  //     sortOrder,
  //     isAdvanceSearchActive ? lastAdvanceFilters : null
  //   );
  // }, [
  //   dateRange,
  //   selectedFilter,
  //   searchQuery,
  //   currentPage,
  //   itemsPerPage,
  //   sortColumn,
  //   sortOrder,
  //   isAdvanceSearchActive,
  //   lastAdvanceFilters,
  // ]);
  useEffect(() => {
    if (!activeFilter) return;

    getSearchAppointmentData(
      inputRef.current?.value || "",
      1,
      15,
      "",
      "DESC",
      isAdvanceSearchActive ? lastAdvanceFilters : null,
    );
  }, [activeFilter]);

  const handleCardClick = (filter: string) => {
    const current = 1;
    const perPage = 15;
    const column = "";
    const order = "DESC";

    setActiveFilter(filter);
    setCurrentPage(current);
    setItemsPerPage(perPage);
    setSortColumn(column);
    setSortOrder(order);
    setSelectedIds([]);
    setSelectedRowData([]);
    setSelectAll(false);
    // getSearchAppointmentData(
    //   inputRef.current?.value || "",
    //   currentPage,
    //   itemsPerPage,
    //   sortColumn,
    //   sortOrder,
    //   isAdvanceSearchActive ? lastAdvanceFilters : null
    // );
  };

  const totalCountReport = useAnimatedCounter(totalCount);
  const completedCountReport = useAnimatedCounter(completedCount);
  const completedPercentReport = useAnimatedCounter(completedPercent);
  const pendingCountReport = useAnimatedCounter(pendingCount);
  const pendingPercentReport = useAnimatedCounter(pendingPercent);
  const canceledCountReport = useAnimatedCounter(canceledCount);
  const canceledPercentReport = useAnimatedCounter(canceledPercent);
  const historyCompletedPercentReport = useAnimatedCounter(
    historyCompletedPercent,
  );
  const historyOverduePercentReport = useAnimatedCounter(historyOverduePercent);
  const historyNearduePercentReport = useAnimatedCounter(historyNearDuePercent);
  const historyWIPPercentReport = useAnimatedCounter(historyWIPPercent);
  const rorCompletedPercentReport = useAnimatedCounter(rorCompletedPercent);
  const rorOverduePercentReport = useAnimatedCounter(rorOverduePercent);
  const rorNearduePercentReport = useAnimatedCounter(rorNearduePercent);
  const rorWIPPercentReport = useAnimatedCounter(rorWIPPercent);
  const editingCompletedPercentReport = useAnimatedCounter(
    editingCompletedPercent,
  );
  const editingwipPercentReport = useAnimatedCounter(editingwipPercent);
  const DoctorwipPercentReport = useAnimatedCounter(doctorwipPercent);
  const DoctorEditorwipPercentReport = useAnimatedCounter(
    doctoreditorwipPercent,
  );

  const allowCheckBox = [
    WEB_ROLE.Case_Manager,
    WEB_ROLE.QME_Doctor,
    WEB_ROLE.Medical_Assistant,
    WEB_ROLE.IndependentQMEDoctor,
    WEB_ROLE.Practice_Manager,
    WEB_ROLE.Supervisor,
    WEB_ROLE.Scheduler,
    WEB_ROLE.App_Admin,
  ].includes(userRole);

  const handleCaseClick = (row: any) => {
    dispatch(setIsDashboard(true));
    dispatch(setNewCaseInFoID(row.caseInfoId));
    sessionStorage.setItem("fromAppointmentTab", "true");
    navigate("/search-case", {
      state: {
        from: "appointment",
        myTodosState: {
          searchQuery,
          dateRange,
          activeFilter,
          activeCard,
          activeSubCard,
          currentPage,
          itemsPerPage,
          sortColumn,
          sortOrder,
        },
      },
    });
  };

  useEffect(() => {
    if (hasInitialized.current) return;
    hasInitialized.current = true;
    const cameFromAppointmentTab = sessionStorage.getItem("fromAppointmentTab");
    if (cameFromAppointmentTab === "true" && location.state?.from === "appointment") {
      const s = location.state.myTodosState;
      setSearchQuery(s.searchQuery);
      setDateRange(s.dateRange);
      setActiveFilter(s.activeFilter);
      setActiveCard(s.activeCard);
      setActiveSubCard(s.activeSubCard);
      setCurrentPage(s.currentPage);
      setItemsPerPage(s.itemsPerPage);
      setSortColumn(s.sortColumn);
      setSortOrder(s.sortOrder);

      if (inputRef.current) {
        inputRef.current.value = s.searchQuery || "";
        getAppointmentSummaryData(s.searchQuery, activeFilter);
      }

      sessionStorage.removeItem("fromAppointmentTab");
    } else {
      handleResetFilters();
    }
  }, []);

  return (
    <>
      <div className="breadcrumbg breadcrumbgNew pb-0 pt-1">
        <Container fluid className="px-5">
          <Stack direction="horizontal" gap={2}>
            <Row className="pt-0 fade-in-left">
              <Col>
                <h4>APPOINTMENT(S)</h4>
              </Col>
            </Row>
          </Stack>
        </Container>
      </div>

      <div className="main_wrapper_section appoinment_wrapper">
        <Loader isLoading={loading} />
        <div className="container-fluid px-5">
          <Row className="g-3 mt-3 align-items-stretch">
            <Col md={6} className="d-flex flex-column">
              <Row className="g-3 flex-grow-1 align-items-stretch">
                <Col md={3} className="pe-md-0 pt-0 mt-0">
                  <Card
                    className={`h-100 todocard111 height70   ${activeCard == "Total" ? "active" : ""
                      }`}
                    style={{
                      backgroundColor: "#bacee7",
                      borderRadius: "5px",
                      border: "1px solid #bacee7",
                    }}
                    onClick={() => {
                      setActiveCard("Total");
                      handleCardClick("APPTALL");
                    }}
                  >
                    <Card.Body className="d-flex flex-column justify-content-between p-1">
                      <div className="d-flex justify-content-between align-items-center">
                        <Card.Title
                          style={{
                            color: "#1F2B30",
                            fontSize: "14px",
                            fontWeight: "600",
                            marginTop: "10px",
                          }}
                        >
                          Total
                        </Card.Title>
                        <span
                          className="material-symbols-outlined"
                          style={{ color: "#1F2B30" }}
                        >
                          functions
                        </span>
                      </div>
                      <div
                        style={{
                          color: "#1F2B30",
                          fontSize: "1.1rem",
                          fontWeight: "600",
                        }}
                      >
                        {totalCountReport}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={3} className="pe-md-0 pt-0 mt-0">
                  <Card
                    className={`h-100 todocard7 height70  ${activeCard == "Completed" ? "active" : ""
                      }`}
                    style={{
                      backgroundColor: "#dbf3db",
                      borderRadius: "5px",
                      border: "1px solid #dbf3db",
                    }}
                    onClick={() => {
                      setActiveCard("Completed");
                      handleCardClick("APPCMPL");
                    }}
                  >
                    <Card.Body className="d-flex flex-column justify-content-between p-1">
                      <div className="d-flex justify-content-between align-items-center">
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#007912",
                            marginTop: "10px",
                          }}
                        >
                          Completed
                        </div>

                        <div className="graph_area_wrapper">
                          <CircularPercentage
                            percentage={completedPercentReport}
                            color="#138425"
                            remainingColor="#B9D9B9"
                          />
                        </div>
                      </div>

                      <div
                        style={{
                          marginTop: "-8px",
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "#007912",
                        }}
                      >
                        {completedCountReport}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={3} className="pe-md-0 pt-0 mt-0">
                  <Card
                    className={`h-100 todocard2 height70   ${activeCard == "Pending" ? "active" : ""
                      }`}
                    style={{
                      backgroundColor: "#fef2c2",
                      borderRadius: "5px",
                      border: "1px solid #fef2c2",
                    }}
                    onClick={() => {
                      setActiveCard("Pending");
                      handleCardClick("APPPEND");
                    }}
                  >
                    <Card.Body className="d-flex flex-column justify-content-between p-1">
                      <div className="d-flex justify-content-between align-items-center">
                        <Card.Title
                          style={{
                            color: "#f7ae46",
                            fontSize: "14px",
                            fontWeight: "600",
                            marginTop: "10px",
                          }}
                        >
                          Pending
                        </Card.Title>
                        <div className="graph_area_wrapper">
                          <CircularPercentage
                            percentage={pendingPercentReport}
                            color="#F6971D"
                            remainingColor="#AC7938"
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          color: "#f7ae46",
                          fontSize: "1.1rem",
                          fontWeight: "600",
                        }}
                      >
                        {pendingCountReport}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={3} className="border_right_devide pt-0 mt-0">
                  <Card
                    className={`h-100 todocard1 height70 ${activeCard == "Cancelled" ? "active" : ""
                      }`}
                    style={{
                      backgroundColor: "#fbe7e8",
                      borderRadius: "5px",
                      border: "1px solid #fbe7e8",
                    }}
                    onClick={() => {
                      setActiveCard("Cancelled");
                      handleCardClick("APPCNCL");
                    }}
                  >
                    <Card.Body className="d-flex flex-column justify-content-between p-1">
                      <div className="d-flex justify-content-between align-items-center">
                        <Card.Title
                          style={{
                            color: "#e63f50",

                            fontSize: "14px",
                            fontWeight: "600",
                            marginTop: "10px",
                          }}
                        >
                          Canceled
                        </Card.Title>

                        <div className="graph_area_wrapper">
                          <CircularPercentage
                            percentage={canceledPercentReport}
                            color="#E74051"
                            remainingColor="#EB9FA6"
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          marginTop: "-8px",
                          color: "#e63f50",
                          fontSize: "1.1rem",
                          fontWeight: "600",
                        }}
                      >
                        {canceledCountReport}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>

            {/* RIGHT HALF – 3 CARDS */}
            <Col md={6} className="d-flex flex-column ">
              <Row className="g-3 flex-grow-1 align-items-stretch">
                <Col md={4} className="pt-0 mt-0 pe-md-0">
                  <Card
                    className={`todocard4 h-100 ${activeCard === "History" ? "active" : ""
                      }`}
                    style={{
                      backgroundColor: "#e9e5fe",
                      borderRadius: "5px",

                      border: "1px solid #9c8cee",
                    }}
                    onClick={() => {
                      setActiveCard("History");
                      handleCardClick("APPHXCL");
                      setActiveSubCard("HCC");
                    }}
                  >
                    <Card.Body className="d-flex flex-column justify-content-between p-1">
                      <div className="d-flex justify-content-between align-items-center ">
                        <Card.Title
                          style={{
                            color: "#6C54E6",
                            fontSize: "14px",
                            fontWeight: "600",
                          }}
                        >
                          History
                        </Card.Title>
                        <span
                          className="material-symbols-outlined"
                          style={{ color: "#6C54E6" }}
                        >
                          today
                        </span>
                      </div>
                      <div className="d-flex justify-content-start forTwoSectionAppointment">
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCardClick("APPHXCL");
                            setActiveSubCard("HCC");
                            setActiveCard("History");
                          }}
                          style={{
                            borderRight: "1px solid transparent",
                            padding: "0px 10px 0px 0px",
                            background:
                              "linear-gradient(to bottom, transparent 10%, #33919f 10%, #33919f 90%, transparent 90%) right / 1px 100% no-repeat",
                          }}
                          className={`px-1 ${activeSubCard == "HCC" ? "active" : ""
                            }`}
                        >
                          <div style={{ fontSize: "11px", color: "#000305" }}>
                            Completed
                          </div>
                          <div
                            style={{
                              fontSize: "15px",
                              color: "#6C54E6",
                              fontWeight: "600",
                            }}
                          >
                            {historyCompletedPercentReport}%
                          </div>
                        </div>
                        {selectedFilter === "Upcoming" && (
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCardClick("APPHXND");
                              setActiveSubCard("HND");
                              setActiveCard("History");
                            }}
                            style={{
                              borderRight: "1px solid transparent",
                              padding: "0px 10px 0px 0px",
                              background:
                                "linear-gradient(to bottom, transparent 10%, #33919f 10%, #33919f 90%, transparent 90%) right / 1px 100% no-repeat",
                            }}
                            className={`px-1 ${activeSubCard == "HND" ? "active" : ""
                              }`}
                          >
                            <div style={{ fontSize: "11px", color: "#000305" }}>
                              Neardue
                            </div>
                            <div
                              style={{
                                fontSize: "15px",
                                color: "#F20C0C",
                                fontWeight: "600",
                              }}
                            >
                              {historyNearDuePercent}%
                            </div>
                          </div>
                        )}
                        {selectedFilter !== "Upcoming" && (
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCardClick("APPHXOD");
                              setActiveSubCard("HOD");
                              setActiveCard("History");
                            }}
                            style={{
                              padding: "0px 10px 0px 10px",
                            }}
                            className={`px-1 ${activeSubCard == "HOD" ? "active" : ""
                              }`}
                          >
                            <div style={{ fontSize: "11px", color: "#000305" }}>
                              Overdue
                            </div>
                            <div
                              style={{
                                fontSize: "15px",
                                color: "#F20C0C",
                                fontWeight: "600",
                              }}
                            >
                              {historyOverduePercentReport}%
                            </div>
                          </div>
                        )}
                        {selectedFilter === "Upcoming" && (
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCardClick("APPHXWP");
                              setActiveSubCard("HWIP");
                              setActiveCard("History");
                            }}
                            style={{
                              padding: "0px 10px 0px 10px",
                            }}
                            className={`px-1 ${activeSubCard == "HWIP" ? "active" : ""
                              }`}
                          >
                            <div style={{ fontSize: "11px", color: "#000305" }}>
                              WIP
                            </div>
                            <div
                              style={{
                                fontSize: "15px",
                                color: "#F20C0C",
                                fontWeight: "600",
                              }}
                            >
                              {historyWIPPercentReport}%
                            </div>
                          </div>
                        )}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4} className="pt-0 mt-0 pe-md-0">
                  <Card
                    className={`todocard5 h-100 ${activeCard === "ROR" ? "active" : ""
                      }`}
                    style={{
                      backgroundColor: "#e4eff1",
                      borderRadius: "5px",

                      border: "1px solid #33919f",
                    }}
                    onClick={() => {
                      setActiveCard("ROR");
                      handleCardClick("APPRRCL");
                      setActiveSubCard("RC");
                    }}
                  >
                    <Card.Body className="d-flex flex-column justify-content-between p-1">
                      <div className="d-flex justify-content-between align-items-center ">
                        <Card.Title
                          style={{
                            color: "#33919f",
                            fontSize: "14px",
                            fontWeight: "600",
                          }}
                        >
                          ROR
                        </Card.Title>
                        <span
                          className="material-symbols-outlined"
                          style={{ color: "#33919f" }}
                        >
                          article
                        </span>
                      </div>
                      <div className="d-flex justify-content-start forTwoSectionAppointment">
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            setActiveCard("ROR");
                            handleCardClick("APPRRCL");
                            setActiveSubCard("RC");
                          }}
                          style={{
                            borderRight: "1px solid transparent",
                            padding: "0px 10px 0px 0px",
                            background:
                              "linear-gradient(to bottom, transparent 10%, #33919f 10%, #33919f 90%, transparent 90%) right / 1px 100% no-repeat",
                          }}
                          className={`px-1 ${activeSubCard == "RC" ? "active" : ""
                            }`}
                        >
                          <div style={{ fontSize: "11px", color: "#000305" }}>
                            Completed
                          </div>
                          <div
                            style={{
                              fontSize: "15px",
                              color: "#33919f",
                              fontWeight: "600",
                            }}
                          >
                            {rorCompletedPercentReport}%
                          </div>
                        </div>
                        {selectedFilter !== "Upcoming" && (
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              setActiveCard("ROR");
                              handleCardClick("APPRROD");
                              setActiveSubCard("ROD");
                            }}
                            style={{
                              padding: "0px 10px 0px 10px",
                            }}
                            className={`px-1 ${activeSubCard == "ROD" ? "active" : ""
                              }`}
                          >
                            <div style={{ fontSize: "11px", color: "#000305" }}>
                              Overdue
                            </div>
                            <div
                              style={{
                                fontSize: "15px",
                                color: "#F20C0C",
                                fontWeight: "600",
                              }}
                            >
                              {rorOverduePercentReport}%
                            </div>
                          </div>
                        )}
                        {selectedFilter === "Upcoming" && (
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              setActiveCard("ROR");
                              handleCardClick("APPRRND");
                              setActiveSubCard("RND");
                            }}
                            style={{
                              borderRight: "1px solid transparent",
                              padding: "0px 10px 0px 0px",
                              background:
                                "linear-gradient(to bottom, transparent 10%, #33919f 10%, #33919f 90%, transparent 90%) right / 1px 100% no-repeat",
                            }}
                            className={`px-1 ${activeSubCard == "RND" ? "active" : ""
                              }`}
                          >
                            <div style={{ fontSize: "11px", color: "#000305" }}>
                              Neardue
                            </div>
                            <div
                              style={{
                                fontSize: "15px",
                                color: "#F20C0C",
                                fontWeight: "600",
                              }}
                            >
                              {rorNearduePercentReport}%
                            </div>
                          </div>
                        )}
                        {selectedFilter === "Upcoming" && (
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              setActiveCard("ROR");
                              handleCardClick("APPRRWP");
                              setActiveSubCard("RIP");
                            }}
                            style={{
                              padding: "0px 10px 0px 10px",
                            }}
                            className={`px-1 ror_last ${activeSubCard == "RIP" ? "active" : ""
                              }`}
                          >
                            <div style={{ fontSize: "11px", color: "#000305" }}>
                              WIP
                            </div>
                            <div
                              style={{
                                fontSize: "15px",
                                color: "#F20C0C",
                                fontWeight: "600",
                              }}
                            >
                              {rorWIPPercent}%
                            </div>
                          </div>
                        )}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                {selectedFilter !== "Upcoming" && (
                  <Col md={4} className="pt-0 mt-0 pe-md-0">
                    <Card
                      className={`todocard6 h-100 ${activeCard === "Editing" ? "active" : ""
                        }`}
                      style={{
                        backgroundColor: "#eee5d4",
                        borderRadius: "5px",

                        border: "1px solid #7c7c7c",
                      }}
                      onClick={() => {
                        setActiveCard("Editing");
                        handleCardClick("APPEDCL");
                        setActiveSubCard("ECL");
                      }}
                    >
                      <Card.Body className="d-flex flex-column justify-content-between p-1">
                        <div className="d-flex justify-content-between align-items-center ">
                          <Card.Title
                            style={{
                              color: "#7B7B7B",
                              fontSize: "14px",
                              fontWeight: "600",
                            }}
                          >
                            Editing
                          </Card.Title>
                          <span
                            className="material-symbols-outlined"
                            style={{ color: "#7b7b7b" }}
                          >
                            contract_edit
                          </span>
                        </div>
                        <div className="d-flex justify-content-start forTwoSectionAppointment">
                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              setActiveCard("Editing");
                              handleCardClick("APPEDCL");
                              setActiveSubCard("ECL");
                            }}
                            style={{
                              borderRight: "1px solid transparent",
                              padding: "0px 10px 0px 0px",
                              background:
                                "linear-gradient(to bottom, transparent 10%, #33919f 10%, #33919f 90%, transparent 90%) right / 1px 100% no-repeat",
                            }}
                            className={`first px-1 ${activeSubCard == "ECL" ? "active" : ""
                              }`}
                          >
                            <div style={{ fontSize: "11px", color: "#000305" }}>
                              Completed
                            </div>
                            <div
                              style={{
                                fontSize: "15px",
                                color: "#33919f",
                                fontWeight: "600",
                              }}
                            >
                              {selectedFilter === "Past" && (
                                <span className="labelBreakCompleted">
                                  &nbsp;
                                </span>
                              )}
                              {editingCompletedPercentReport}%
                            </div>
                          </div>
                          {selectedFilter !== "Past" || (
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                setActiveCard("Editing");
                                handleCardClick("APPDCWP");
                                setActiveSubCard("DOD");
                              }}
                              style={{
                                borderRight: "1px solid transparent",
                                padding: "0px 10px 0px 0px",
                                background:
                                  "linear-gradient(to bottom, transparent 10%, #33919f 10%, #33919f 90%, transparent 90%) right / 1px 100% no-repeat",
                              }}
                              className={`px-1 ${activeSubCard == "DOD" ? "active" : ""
                                }`}
                            >
                              <div
                                style={{ fontSize: "11px", color: "#000305" }}
                              >
                                <span className="labelBreak">WIP</span>
                                <span className="labelBreak labelBreakNext">
                                  Doctor
                                </span>
                              </div>
                              <div
                                style={{
                                  fontSize: "15px",
                                  color: "#F20C0C",
                                  fontWeight: "600",
                                }}
                              >
                                {DoctorwipPercentReport}%
                              </div>
                            </div>
                          )}
                          {selectedFilter !== "Past" || (
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                setActiveCard("Editing");
                                handleCardClick("APPEDWP");
                                setActiveSubCard("EOD");
                              }}
                              style={{
                                padding: "0px 10px 0px 10px",
                              }}
                              className={`px-1 ${activeSubCard == "EOD" ? "active" : ""
                                }`}
                            >
                              <div
                                style={{ fontSize: "11px", color: "#000305" }}
                              >
                                <span className="labelBreak"> WIP</span>
                                <span className="labelBreak labelBreakNext">
                                  {" "}
                                  Editor
                                </span>
                              </div>
                              <div
                                style={{
                                  fontSize: "15px",
                                  color: "#F20C0C",
                                  fontWeight: "600",
                                }}
                              >
                                {editingwipPercentReport}%
                              </div>
                            </div>
                          )}
                          {selectedFilter !== "Today" || (
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                setActiveCard("Editing");
                                handleCardClick("APPEDDC");
                                setActiveSubCard("EDEWIP");
                              }}
                              style={{
                                padding: "0px 10px 0px 10px",
                              }}
                              className={`px-1 ${activeSubCard == "EDEWIP" ? "active" : ""
                                }`}
                            >
                              <div
                                style={{ fontSize: "11px", color: "#000305" }}
                              >
                                WIP
                              </div>
                              <div
                                style={{
                                  fontSize: "15px",
                                  color: "#F20C0C",
                                  fontWeight: "600",
                                }}
                              >
                                {editingwipPercentReport}%
                              </div>
                            </div>
                          )}
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                )}
              </Row>
            </Col>
            <div
              className="my-3"
              style={{ background: "#0092D5", height: "2px" }}
            ></div>
          </Row>

          <div className="mt-0 mb-3">
            <Row className="align-items-center justify-content-between mb-3">
              {/* Title */}
              <Col xs="auto" className="sectionTitle noborder pe-4">
                List ({appointmentCount})
              </Col>

              <Col xs="auto">
                <div className="d-flex flex-wrap align-items-center gap-2">
                  <ToggleButtonGroup
                    type="radio"
                    name="appointmentFilter"
                    value={selectedFilter}
                    onChange={handleFilterChange}
                    className="appointment-ui"
                  >
                    <ToggleButton
                      id="tbg-radio-1"
                      variant="outline-secondary"
                      value="Past"
                      className="px-3"
                    >
                      <span className="d-flex align-items-center gap-1">
                        <span className="material-symbols-outlined">
                          history
                        </span>
                        Past
                      </span>
                    </ToggleButton>
                    <ToggleButton
                      id="tbg-radio-2"
                      variant="outline-secondary"
                      value="Today"
                      className="px-3"
                    >
                      <span className="d-flex align-items-center gap-1">
                        <span className="material-symbols-outlined">event</span>
                        Today
                      </span>
                    </ToggleButton>
                    <ToggleButton
                      id="tbg-radio-3"
                      variant="outline-secondary"
                      value="Upcoming"
                      className="px-3"
                    >
                      <span className="d-flex align-items-center gap-1">
                        <span className="material-symbols-outlined">alarm</span>
                        Upcoming
                      </span>
                    </ToggleButton>
                  </ToggleButtonGroup>
                  {/* Date Picker */}
                  {(selectedFilter === "Past" ||
                    selectedFilter === "Upcoming") && (
                      <div
                        className="date-picker-container appointment-data-range customDrodownControlDAtepicker"
                        style={{ width: "280px" }}
                      >
                        <DateRangePicker
                          label=""
                          onChange={handleDateRangeChange}
                          startDate={dateRange[0]}
                          endDate={dateRange[1]}
                          minDate={computedMinDate}
                          maxDate={computedMaxDate}
                        />
                      </div>
                    )}
                  {/* Search Box */}
                  <InputGroup className="w-auto">
                    <InputGroup.Text className="px-2">
                      <span className="material-symbols-outlined text-black-50">
                        search
                      </span>
                    </InputGroup.Text>
                    <Form.Control
                      ref={inputRef}
                      aria-label="Search"
                      onChange={(e) => handleInputChange(e.target.value.trim())}
                      onPaste={(e) => {
                        e.preventDefault();
                        const text = e.clipboardData.getData("text").trim();
                        handleInputChange(text);
                        if (inputRef.current) inputRef.current.value = text;
                      }}
                    />
                    {/* <Filter
                      onClick={OpenAdvanceserachPopup}
                      className="w-5 h-5 text-gray-500 ml-2 cursor-pointer filtericon"
                    /> */}
                  </InputGroup>
                  {/* Reset Button */}
                  <Button
                    className="d-flex align-items-center"
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      padding: "10px",
                      fontSize: "22px",
                    }}
                    onClick={handleResetFilters}
                  >
                    <span className="material-icons reset_ic0">
                      restart_alt
                    </span>
                  </Button>
                  {/* Actions Dropdown */}

                  <Button
                    variant="outline"
                    className="d-flex align-items-center btn-text-border p-1"
                    onClick={handleOpenNewTabForMap}
                    disabled={!appointmentData?.length}
                  >
                    <img src="/map.png" alt="map" />
                  </Button>
                  <Dropdown as={ButtonGroup}>
                    <Dropdown.Toggle
                      variant="outline"
                      className="d-flex align-items-center btn-text-border appoinmentdropdown p-2"
                    >
                      <span className="material-symbols-outlined">
                        download
                      </span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={handleExportExcel}>
                        Export to Excel
                      </Dropdown.Item>
                      <Dropdown.Item onClick={handleExportPDF}>
                        Export to PDF
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  {selectedIds?.length > 0 && (
                    <AppointmentActionsDropdown
                      name="Actions"
                      options={filteredActionOptions}
                      value={selectedAction}
                      onChange={handleActionChange}
                    />
                  )}
                </div>
              </Col>
            </Row>
          </div>

          <div className="mb-2">
            <AppointmentDataTable
              headers={AppointmentHeader}
              rows={appointmentData}
              isCheckbox={allowCheckBox ? true : false}
              onSortAction={handleSortAction}
              selectedRowIds={selectedIds}
              onCheckboxSelect={handleCheckboxSelect}
              onSaveSuccess={refreshAppointmentData}
              selectAll={selectAll}
              setSelectAll={setSelectAll}
              filteredActionOptions={filteredActionOptions}
              onAction={handleTableAction}
              userRole={userRole}
              allowCheckBox={allowCheckBox}
              onCaseClick={handleCaseClick}
            />
          </div>
          <div className="d-flex justify-content-between align-items-center mt-0 mb-4">
            {/* Display entries text on the left */}
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6 showingData_wrapper">
                  <span>{entriesText}</span>
                </div>
                <div className="col-md-6">
                  <div className="d-flex flex-row-reverse ">
                    <CustomPagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={paginate}
                    />
                    <TableRowsPerPage
                      value={itemsPerPage}
                      onSelect={handleRowsPerPageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AppointmentActionDrawer
        title={drawerTitle}
        open={showAppointmentMAActionDrawer}
        onClose={handlecloseActionDrawer}
        placement="end"
      >
        {selectedAction === "Assign Medical Assistant" && (
          <MedicalAssignment
            selectedRows={selectedRowData}
            onClose={handlecloseActionDrawer}
            onSaveSuccess={refreshAppointmentData}
          />
        )}
        
      </AppointmentActionDrawer>
        {/* <AppointmentActionDrawer
        title={drawerTitle}
        open={showAssignEditor}
        onClose={handlecloseActionDrawer}
        placement="end"
      >
        {selectedAction === "Assign My Todo" && (
          <AssignMyTodo
            userData={selectedRowData}
            onClose={handlecloseActionDrawer}
            onSaveSuccess={refreshAppointmentData}
          />
        )}
      </AppointmentActionDrawer> */}

        <AppointmentActionDrawer
        title={drawerTitle}
        open={showAssignEditor}
        onClose={handlecloseActionDrawer}
        placement="end"
      >
        {selectedAction === "Change Staff" &&  (
          <AssignMyTodo
           userData={selectedRowData}
            onClose={handlecloseActionDrawer}
            onSaveSuccess={refreshAppointmentData}
          />
        )}
      </AppointmentActionDrawer>


      <AppointmentActionDrawer
        title={
          <div className="d-flex align-items-center">
            <span className="rushIcon1">
              <span className="material-symbols-outlined me-2 rushicon p-1">
                sprint
              </span>
            </span>
            <span className="rushTitle"> Rush Notes</span>
          </div>
        }
        open={showRushNotesActionDrawer}
        onClose={handlecloseActionDrawer}
        placement="end"
      >
        {selectedCaseId && (
          <GetAppointmentNotes
            caseInfoID={selectedCaseId}
            onClose={handlecloseActionDrawer}
            subjectQmeScheduleID={selectedQMEScheduleId}
          />
        )}
      </AppointmentActionDrawer>
      <DoctorCommonDrawer
        title={drawerTitle}
        open={showAppointmentActionDrawer}
        onClose={handlecloseActionDrawer}
        placement="end"
        width={selectedAction === "Assign QME Doctor" ? "40%" : "60%"}
        height={selectedAction === "Assign QME Doctor" ? "400px" : "auto"}
        top={selectedAction === "Assign QME Doctor" ? "auto" : "175px"}
      >
        {selectedAction === "DWC Extension" && (
          <EditorDWCExtensionRequest
            selectedRowIds={selectedIds}
            selectedRows={selectedRowData}
            dwcExtensionIds={0}
            subjectQmeScheduleID={selectedRowData[0]?.subjectQmeScheduleId}
            onClose={handlecloseActionDrawer}
            onSaveSuccess={refreshAppointmentData}
            dwcStatus={selectedRowData[0]?.dwcStatusDesc}
            caseInfoId={selectedRowData[0]?.caseInfoId}
          />
        )}
      </DoctorCommonDrawer>

      {showCommonModal && (
        <AppointmentActionCommonPopUp
          selectedRows={selectedRowData}
          title={drawerTitle}
          value={actionValue}
          show={showCommonModal}
          onHide={handleCloseCommonModal}
          onSaveSuccess={handleSaveFilters}
          userRole={userRole}
        />
      )}

      {isPopupOpen && (
        <AppointmentAdvanceSearch
          isOpen={isPopupOpen}
          onClose={CloseAdvanceserachPopup}
          selectedTab="Case info"
          onSearch={(filters) => {
            setLastAdvanceFilters(filters); // to retain on pagination/filter/sort
            setIsAdvanceSearchActive(true);
            getSearchAppointmentData(
              "",
              1,
              itemsPerPage,
              sortColumn,
              sortOrder,
              filters,
            );
            CloseAdvanceserachPopup();
          }}
          initialFilters={lastAdvanceFilters}
          onReset={() => {
            setIsAdvanceSearchActive(false);
            CloseAdvanceserachPopup();
            getSearchAppointmentData(
              "",
              1,
              itemsPerPage,
              sortColumn,
              sortOrder,
            );
            setLastAdvanceFilters(null);
          }}
        />
      )}
    </>
  );
};

export default Appointments;
